module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dialogo dialogo_ativo dialogo_pequeno dialogo-de-situacao",
    attrs: {
      "role": "dialog",
      "aria-modal": "true",
      "aria-label": _vm.dialogo.titulo
    },
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.fechar.apply(null, arguments)
      }
    }
  }, [_c('form', {
    staticClass: "dialogo__container formulario",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.confirmar.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "dialogo__cabecalho dialogo-de-situacao__cabecalho"
  }, [_c('h3', {
    staticClass: "titulo titulo_medio dialogo-de-situacao__titulo"
  }, [_vm._v("\n        " + _vm._s(_vm.dialogo.titulo) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "dialogo__botao-fechar dialogo-de-situacao__botao-fechar",
    attrs: {
      "type": "button",
      "aria-label": "Fechar"
    },
    on: {
      "click": _vm.fechar
    }
  }, [_c('i', {
    staticClass: "far fa-times",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialogo__corpo dialogo-de-situacao__corpo"
  }, [_c('div', {
    staticClass: "dialogo-de-situacao__transicao"
  }, [_c('span', {
    class: ['tags', 'tags_grande', _vm.classeDoTom(_vm.situacaoAtual)]
  }, [_vm._v(_vm._s(_vm.situacaoAtual))]), _vm._v(" "), _c('i', {
    staticClass: "far fa-arrow-right dialogo-de-situacao__seta",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    class: ['tags', 'tags_grande', _vm.classeDoTom(_vm.acao.proximaSituacao)]
  }, [_vm._v(_vm._s(_vm.acao.proximaSituacao))])]), _vm._v(" "), _c('p', {
    staticClass: "texto texto_pequeno texto_cor-cinza u-margem-superior-mini"
  }, [_vm._v("\n        " + _vm._s(_vm.dialogo.mensagem) + "\n      ")]), _vm._v(" "), (_vm.dialogo.responsavel) ? _c('p', {
    staticClass: "dialogo-de-situacao__responsavel"
  }, [_c('i', {
    staticClass: "far fa-user dialogo-de-situacao__icone-do-responsavel",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "texto texto_medio"
  }, [_vm._v("Passa a ser responsável:\n          "), _c('span', {
    staticClass: "u-texto-negrito"
  }, [_vm._v(_vm._s(_vm.dialogo.responsavel))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dialogo-de-situacao__campos"
  }, _vm._l((_vm.dialogo.campos), function(campo) {
    return _c('div', {
      key: campo.chave,
      class: [
        'dialogo-de-situacao__campo',
        {
          'dialogo-de-situacao__campo_metade': campo.meiaLargura
        } ]
    }, [(_vm.campoEstaOculto(campo)) ? _c('button', {
      staticClass: "botao botao_sem-preenchimento botao_cor-terciaria botao_com-icone-para-esquerda dialogo-de-situacao__botao-expandir",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.expandirCampo(campo.chave)
        }
      }
    }, [_c('i', {
      staticClass: "far fa-plus",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n            " + _vm._s(campo.textoParaExibir || campo.rotulo) + "\n          ")]) : [_c('label', {
      staticClass: "formulario__label",
      attrs: {
        "for": _vm.idDoCampo(campo)
      }
    }, [_vm._v("\n              " + _vm._s(campo.rotulo) + "\n              "), (campo.obrigatorio) ? _c('span', {
      staticClass: "dialogo-de-situacao__obrigatorio",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("*")]) : _vm._e()]), _vm._v(" "), (campo.tipo === 'textarea') ? _c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.valores[campo.chave]),
        expression: "valores[campo.chave]"
      }],
      staticClass: "formulario__textarea dialogo-de-situacao__textarea",
      class: {
        formulario__input_erro: _vm.erros[campo.chave]
      },
      attrs: {
        "id": _vm.idDoCampo(campo),
        "placeholder": campo.placeholder,
        "required": campo.obrigatorio,
        "rows": "4"
      },
      domProps: {
        "value": (_vm.valores[campo.chave])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.valores, campo.chave, $event.target.value)
        }
      }
    }) : (campo.tipo === 'data') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.valores[campo.chave]),
        expression: "valores[campo.chave]"
      }],
      staticClass: "formulario__input",
      class: {
        formulario__input_erro: _vm.erros[campo.chave]
      },
      attrs: {
        "id": _vm.idDoCampo(campo),
        "type": "date",
        "max": campo.impedirDataFutura ? _vm.hoje : null,
        "required": campo.obrigatorio
      },
      domProps: {
        "value": (_vm.valores[campo.chave])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.valores, campo.chave, $event.target.value)
        }
      }
    }) : (campo.mascara) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.valores[campo.chave]),
        expression: "valores[campo.chave]"
      }, {
        name: "mask",
        rawName: "v-mask",
        value: (campo.mascara),
        expression: "campo.mascara"
      }],
      staticClass: "formulario__input",
      class: {
        formulario__input_erro: _vm.erros[campo.chave]
      },
      attrs: {
        "id": _vm.idDoCampo(campo),
        "type": "text",
        "placeholder": campo.placeholder,
        "required": campo.obrigatorio
      },
      domProps: {
        "value": (_vm.valores[campo.chave])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.valores, campo.chave, $event.target.value)
        }
      }
    }) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.valores[campo.chave]),
        expression: "valores[campo.chave]"
      }],
      staticClass: "formulario__input",
      class: {
        formulario__input_erro: _vm.erros[campo.chave],
        'dialogo-de-situacao__input_maiusculo': campo.maiusculo,
      },
      attrs: {
        "id": _vm.idDoCampo(campo),
        "type": "text",
        "placeholder": campo.placeholder,
        "required": campo.obrigatorio
      },
      domProps: {
        "value": (_vm.valores[campo.chave])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.valores, campo.chave, $event.target.value)
        }
      }
    }), _vm._v(" "), (_vm.erros[campo.chave]) ? _c('p', {
      staticClass: "formulario__mensagem formulario__mensagem_erro"
    }, [_c('i', {
      staticClass: "far fa-exclamation-circle formulario__mensagem-icone",
      attrs: {
        "aria-hidden": "true"
      }
    }), _vm._v("\n              " + _vm._s(_vm.erros[campo.chave]) + "\n            ")]) : (campo.ajuda) ? _c('p', {
      staticClass: "dialogo-de-situacao__ajuda"
    }, [_vm._v("\n              " + _vm._s(campo.ajuda) + "\n            ")]) : _vm._e()]], 2)
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "dialogo__rodape dialogo-de-situacao__rodape"
  }, [_c('button', {
    staticClass: "botao botao_medio",
    class: _vm.classesDoBotaoDeConfirmacao,
    attrs: {
      "type": "submit",
      "disabled": _vm.carregando
    }
  }, [_vm._v("\n        " + _vm._s(_vm.dialogo.textoDeConfirmacao) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_medio botao_cor-cinza botao_sem-preenchimento",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fechar
    }
  }, [_vm._v("\n        Cancelar\n      ")])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-58635927", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58635927"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/DialogoDeSituacao.vue
// module id = 1118
// module chunks = 1